import * as React from "react";
import { colors } from "@aifi-ml/design-system-variables";

interface GenericErrorIconProps {
  color?: string;
  width?: number;
  height?: number;
}

export const GenericErrorIcon: React.FC<GenericErrorIconProps> = ({
  color = colors.light["color/text/general/secondary"],
  width = 40,
  height = 40,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M20 21.25V12.5M35 20C35 28.2843 28.2843 35 20 35C11.7157 35 5 28.2843 5 20C5 11.7157 11.7157 5 20 5C28.2843 5 35 11.7157 35 20Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M20 28.75C21.0355 28.75 21.875 27.9105 21.875 26.875C21.875 25.8395 21.0355 25 20 25C18.9645 25 18.125 25.8395 18.125 26.875C18.125 27.9105 18.9645 28.75 20 28.75Z"
      fill={color}
    />
  </svg>
);
